import { Component } from '@angular/core';
import { ApiService } from './api.service';
import { Router } from '@angular/router';

import { LOCALE_ID,Inject } from '@angular/core';

import { BreakpointObserver, Breakpoints,BreakpointState } from '@angular/cdk/layout';

import { TranslateService } from './translate.service';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
/*
import { Router } from '@angular/router';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
*/

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  
  // title = 'Yacht Club Italiano';

  appStatus : number;
  isScreenLarge: boolean;
  isScreenVerySmall: boolean;


  constructor(private router: Router, 
              public breakpointObserver: BreakpointObserver, 
              @Inject(LOCALE_ID) protected localeId: string,
              public translate: TranslateService,
              public api:ApiService){

                // console.log("app.component.constructor");
                translate.use('en').then(() => {
                  console.log("translate promised has been called");
                  // console.log(translate.data);
                });
              };
    
  ngOnInit(){
    console.log("AppComponent::ngOnInit");
    console.log("AppComponent::localeId="+this.localeId);
    console.log("navigator.language || navigator.userLanguage="+navigator.language);
    this.isScreenLarge = false;
    this.isScreenVerySmall = false;
    
    this.breakpointObserver.observe(['(min-width: 960px)']).subscribe((state: BreakpointState) => {
      if (state.matches) {
        console.log('AppComponent :: Viewport is 1023px or over!');
        this.isScreenLarge = true;
      }
      else {
        console.log('AppComponent :: Viewport is getting smaller than 1023px !');
        this.isScreenLarge = false;
      }
    })

    this.breakpointObserver.observe(['(min-width: 400px)']).subscribe((state: BreakpointState) => {
      if (state.matches) {
        console.log('AppComponent :: Viewport is 400px or over!');
        this.isScreenVerySmall = false;
      }
      else {
        console.log('AppComponent :: Viewport is getting smaller than 400px !');
        this.isScreenVerySmall = true;
      }
    })

    // console.log(this.router);
    this.appStatus=0; 
    this.router.navigate(['/login']); 
       
    
    // TODO da spostare nel form Login
    // this.api.login("marco.manuelli@sangiorgiosein.com","12345");

    this.setLang("it");

  }

  setLang(lang: string) {
    this.translate.use(lang);
  }

  OnTabClick(event){
    console.log(event);
  }
  
  pageChange(event) {
    // console.log("Selected tab is n." + event.index);
    console.log(event);
    // TODO devi investigare la selezione manuale di una route con il metodo navigate() del componente router !!
    // switch (event.index) {
    //   case 0 : this.router.navigate(['/login']); break;
    //   case 1 : this.router.navigate(['/events']); break;
    //   case 2 : this.router.navigate(['/entries']); break;
    //   case 3 : this.router.navigate(['/new-entry']); break;
    // } 
  }
  
  logout(){
    // Questa funzione serve a fare refresh interfaccia, non basta la chiama alla api logout
    this.router.navigate(['/login']);
    this.api.logout(); 
  }

}
